import { selectTransactionNatureList, selectValuationMethodList } from '@EUForms/selectors'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import ECCNNumber from './ECCNNumber'

const MerchandiseDetail = ({ saveData, updateData, renderForm, merchandiseId, invoiceId, procedure }) => {
  const { isImportShipment } = useCurrentShipmentType()
  const natureOfTransactionList = useSelector(selectTransactionNatureList)
  const valuationMethodList = useSelector(selectValuationMethodList)
  const dataSource = useSelector((state) => state.invoiceReducer.invoice.merchandiseMap[merchandiseId])
  const packageDataSource = useSelector(state => state.invoiceReducer.invoice.merchandiseMap[merchandiseId]?.packagesList) || []
  const natureOfTransactionAtShipment = useSelector((state) => state.invoiceReducer.invoice?.invoiceUpperHeader?.natureOfTransaction)
  const renderAtLast = useCallback(
    ({
      disableFields,
      customValue,
      quotaNumber,
      valuationMethod,
      natureOfTransaction,
      upu = '',
      eccn = '',
      commodityCode,
      onDropDownChange,
      onChangeHandler,
      onBlurHandler,
      translate,
      isMerchandiseDisabled
    }) => {
      if (!isImportShipment) return (
        <>
          <Grid.Column>
            <InputField
              isLabel={false}
              id={`upu-${merchandiseId}`}
              type='text'
              label={translate('UPU', { ns: ['default', 'items'] })}
              value={upu}
              name='upu'
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              isDisabled={isMerchandiseDisabled}
            />
          </Grid.Column>
          <Grid.Column>
            <ECCNNumber
              label='ECCN'
              name='eccn'
              translate={translate}
              commodityCode={dataSource?.commodityCode}
              selectedValue={eccn}
              onSelect={({ value }) => {
                onDropDownChange({}, { value, name: 'eccn' })
              }}
              onBlur={({ value }) => {
                if(!value){ onDropDownChange({}, { value:' ', name: 'eccn' }) }                
              }}
              isDisabled={isMerchandiseDisabled}
            />
          </Grid.Column>
          <Grid.Column>
            <DropDown
              id={`NatureOfTransaction${merchandiseId}`}
              label={translate('NATURE_OF_TRANSACTION', { ns: ['default', 'items'] })}
              labelClass='text-none'
              boxNumber='8/5'
              direction='left'
              data={natureOfTransactionList}
              value={natureOfTransaction}
              text={natureOfTransaction}
              name='natureOfTransaction'
              onChange={onDropDownChange}
              clearable
              isDisabled={isMerchandiseDisabled||procedure === 'B3'||!!natureOfTransactionAtShipment||null}
            />
          </Grid.Column>
        </>
      )
      return (
        <>
          <Grid.Column>
            <InputField
              isLabel={false}
              id={`quotaNumber${merchandiseId}`}
              type='text'
              label={translate('QUOTA', { ns: ['default', 'items'] })}
              value={quotaNumber}
              name='quotaNumber'
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              isDisabled={isMerchandiseDisabled}
            />
          </Grid.Column>
          <Grid.Column>
            <DropDown
              id={`valuationMethod${merchandiseId}`}
              label={translate('VALUATION_METHOD', { ns: ['default', 'items'] })}
              labelClass='text-none'
              direction='left'
              boxNumber='4/16'
              name='valuationMethod'
              onChange={onDropDownChange}
              data={valuationMethodList}
              clearable
              value={valuationMethod}
              text={valuationMethod}
              isDisabled={isMerchandiseDisabled}
            />
          </Grid.Column>

          <Grid.Column>
            <DropDown
              id={`NatureOfTransaction${merchandiseId}`}
              label={translate('NATURE_OF_TRANSACTION', { ns: ['default', 'items'] })}
              labelClass='text-none'
              boxNumber='8/5'
              direction='left'
              data={natureOfTransactionList}
              value={natureOfTransaction}
              text={natureOfTransaction}
              name='natureOfTransaction'
              onChange={onDropDownChange}
              clearable
              isDisabled={isMerchandiseDisabled}
            />
          </Grid.Column>
        </>
      )
    },
    [dataSource?.commodityCode, natureOfTransactionAtShipment]
  )
  const dispatch = useDispatch()
  const onBlur = useCallback(
    //save Api
    (value, name) => saveData({ merchandiseId, data: { [name]: value } }),

    [saveData]
  )
  const onChange = useCallback(
    (value, name) => dispatch(updateData({ merchandiseId, data: { [name]: value } })),
    [merchandiseId, updateData]
  )
  const onSelect = useCallback(
    (...params) => {
      onChange(...params)
      onBlur(...params)
    },
    [onChange, onBlur]
  )
  return renderForm && renderForm({ onBlur, onSelect, onChange, dataSource, renderAtLast, packageDataSource, invoiceId })
}

export default MerchandiseDetail
